export default __webpack_public_path__ + "static/media/motorcycle1.c2c48a65.png";